import apiClient from 'ps-components/lib/apiClient';

export const BACK_TO_LIST = 'BACK_TO_LIST',
  EMPLOYEE_DATA_START = 'EMPLOYEE_DATA_START',
  EMPLOYEE_DATA_SUCCESS = 'EMPLOYEE_DATA_SUCCESS',
  EMPLOYEE_DATA_ERROR = 'EMPLOYEE_DATA_ERROR',
  CLICKED_GRADE = 'CLICKED_GRADE',
  GRADE_TITLE_SUCCESS = 'GRADE_TITLE_SUCCESS',
  SET_GRADE_INDEX_RANGE = 'SET_GRADE_INDEX_RANGE',
  VIEW_GRADE_SAVE_STATE = 'VIEW_GRADE_SAVE_STATE',
  JOBS_IN_GRADE_SET_TEXT = 'JOBS_IN_GRADE_SET_TEXT',
  JOBS_IN_GRADE_SET_CURRENT_TAB = 'JOBS_IN_GRADE_SET_CURRENT_TAB';

export const backToList = e => {
  return {
    type: BACK_TO_LIST
  };
};

export const clickGrade = (modelId, cellData, idx, idxRangeMax, basis) => {
  return async dispatch => {
    try {
      const metaData = {
        limit: 50,
        offset: 0,
        sortOn: 'proposed',
        sortBy: 'full_name',
        sortDirection: 'asc',
        filter: 'all'
      };
      dispatch({ type: EMPLOYEE_DATA_START });
      const parseModelId = parseInt(modelId);
      if (isNaN(parseModelId)) throw Error('Invalid ModelId specified.');
      const results = await apiClient.apiPost('/api/structure-modeling/analytics/grade-view/getGrade', {
        grade: cellData.grade,
        modelId: modelId,
        basis,
        metaData: metaData
      });
      if (idxRangeMax !== undefined)
        dispatch({
          type: SET_GRADE_INDEX_RANGE,
          maxGradeIdx: idxRangeMax
        });
      dispatch({
        type: CLICKED_GRADE,
        payload: cellData,
        modelId: modelId,
        prevGradeIdx: idx - 1,
        nextGradeIdx: idx + 1
      });
      dispatch({ type: GRADE_TITLE_SUCCESS, title: cellData.grade });
      dispatch({ type: EMPLOYEE_DATA_SUCCESS, payload: results, offset: metaData.offset });
    } catch (error) {
      dispatch({ type: EMPLOYEE_DATA_ERROR });
      throw error;
    }
  };
};

export const getEmployees = (modelId, grade, limit, offset, columnSort, sortOn, show, showOn, basis) => {
  return async dispatch => {
    try {
      let filter = 'all';
      if (show === 'above') {
        if (showOn === 'current') {
          filter = 'above_current';
        } else {
          filter = 'above_proposed';
        }
      } else if (show === 'below') {
        if (showOn === 'current') {
          filter = 'below_current';
        } else {
          filter = 'below_proposed';
        }
      }
      const metaData = {
        limit: limit,
        offset: offset,
        sortOn: sortOn,
        sortBy: columnSort.columnName,
        sortDirection: columnSort.order,
        filter: filter
      };
      dispatch({ type: EMPLOYEE_DATA_START });
      const parseModelId = parseInt(modelId);
      if (isNaN(parseModelId)) throw Error('Invalid ModelId specified.');
      const results = await apiClient.apiPost('/api/structure-modeling/analytics/grade-view/getGrade', {
        grade,
        basis,
        modelId,
        metaData
      });
      dispatch({ type: EMPLOYEE_DATA_SUCCESS, payload: results, offset: metaData.offset });
    } catch (error) {
      dispatch({ type: EMPLOYEE_DATA_ERROR });
      throw error;
    }
  };
};

export const saveState = state => {
  return {
    type: VIEW_GRADE_SAVE_STATE,
    payload: state
  };
};

export const setSearchText = text => {
  return {
    type: JOBS_IN_GRADE_SET_TEXT,
    payload: text
  };
};

export const setCurrentTab = tab => {
  return {
    type: JOBS_IN_GRADE_SET_CURRENT_TAB,
    payload: tab
  };
};
